import { DocumentIcon } from "staysure-component-library";

import { IconButtonWrapper } from "@/components/atoms/button-wrapper/button-wrapper";
import TextSelectionButton from "@/components/atoms/text-selection-button/text-selection-button";

import { openInNewTab } from "./docs.utils";

function DocumentItem({
  name,
  link,
  id,
}: Readonly<{
  name: string;
  link: string;
  id?: string | number;
}>) {
  return (
    <div className="items-start lg:flex lg:flex-col">
      <div className={`flex items-center h-fit  `}>
        <IconButtonWrapper
          id={`document-icon-${id ?? "default"}`}
          hierarchy="tertiary"
          btnType="icon"
          isDisabled
          icon={<DocumentIcon stroke="rgba(39, 36, 39, 1)" />}
          className="!max-w-[24px] h-[24px] text-[24px] text-text-on-primary !px-0 !max-h-[27px] !my-0 !py-0 !bg-surface-neutral-option-1 active:!bg-surface-neutral-option-1 hover:!bg-surface-neutral-option-1"
        />
        <span className="text-sm md:text-xs font-semibold leading-[27px] lg:pl-spacing-xxs pl-spacing-xs">
          <TextSelectionButton
            id={`document-${id}`}
            label={name}
            className="text-[18px] font-body-font font-[600] align-top leading-[27px] !text-left h-fit hover:text-interactive-secondary-default hover:bg-surface-neutral-option-1 !px-0"
            onClick={() => openInNewTab(link)}
          />
        </span>
      </div>
    </div>
  );
}

export default DocumentItem;
